import request from '@/utils/request'

/**
 *获取员工列表
 * @param {*} data 
 */
export function webLogin(data){
    return request({
        url: '/login/index',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js